import React from 'react';
import './ProposalListSkeleton.css';

/**
 * Skeleton loader for proposal lists (ProposedTimeRequests and MyTimeProposals)
 */
const ProposalListSkeleton = () => {
  return (
    <div className="pls-skeleton-container">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="pls-skeleton-item">
          <div className="pls-skeleton-content">
            <div className="pls-skeleton-name" />
            <div className="pls-skeleton-badge" />
          </div>
          <div className="pls-skeleton-time" />
        </div>
      ))}
    </div>
  );
};

export default ProposalListSkeleton;
